var React = require('react');

function DocumentPencil32px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M31.885 6.989v.003l-.002 19.11v.009c0 .083-.028.157-.047.235-.012.048-.009.098-.029.145l-.001.005-.003.005-1.986 4.815a.994.994 0 0 1-1.84 0l-1.992-4.825a.98.98 0 0 1 .045-.831V7.443a.977.977 0 0 1-.121-.452.98.98 0 0 1 .121-.453V3.455a.98.98 0 0 1-.121-.453c0-1.65 1.34-2.993 2.988-2.993a2.993 2.993 0 0 1 2.986 2.993c0 .018-.009.034-.01.052.001.021.012.039.012.061v3.874zM30.03 3.481a.97.97 0 0 1-.139-.479.995.995 0 1 0-1.99 0c0 .02-.01.037-.012.057.002.019.012.036.012.056v2.878h2.129V3.481zm0 4.507h-2.129v17.925l.996 2.41 1.07-2.594c.015-.036.044-.06.063-.094V7.988zm-7.11 3.093V29.94a1.997 1.997 0 0 1-1.992 1.995H2.002A1.997 1.997 0 0 1 .01 29.94V2.005C.01.904.904.009 2.002.009h9.961c.022 0 .04.011.061.012.09.006.178.023.263.053.032.012.064.02.095.034a.994.994 0 0 1 .28.189l.006.005 9.852 9.867c.032.023.048.061.077.087.029.027.05.058.076.087.153.176.267.388.267.641 0 .034-.016.063-.02.097zM2.002 29.94l19.028.03V11.982h-9.067c-.551 0-.933-.461-.933-1.012v-9h-9l-.028 27.97zM12.959 3.415v6.571h6.56l-6.56-6.571z","key":1})]);
}

DocumentPencil32px.displayName = "DocumentPencil32px";

DocumentPencil32px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 31.91 31.94"};

module.exports = DocumentPencil32px;

DocumentPencil32px.default = DocumentPencil32px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/32px/document-pencil-32px.svg
// module id = 1096
// module chunks = 0